export const environment = {
	production: true,
	apiRoot: "##{apiRoot}##",
	authApiRoot: "##{authApiRoot}##",
	appDisplayName: "##{appDisplayName}##",
	appName: "##{appName}##",
	appVersion: "##{appVersion}##",
	appVersionName: "##{appVersionName}##",
	authority: "##{authority}##",
	clientId: "##{clientId}##",
	clientSecret: "##{clientSecret}##",
	enableAdminSolicitationReading: "##{enableAdminSolicitationReading}##",
	enableIntegrationMode: "##{enableIntegrationMode}##",
	googleAnalyticsCode: "##{googleAnalyticsCode}##",
	hostHub: "##{hostHub}##",
	sumUpAffiliateKey: "##{sumUpAffiliateKey}##",
	sumUpCallbackPath: "##{sumUpCallbackPath}##",
	sumUpSchemeUrl: "##{sumUpSchemeUrl}##",
	systemPayPaymentUrl: "##{systemPayPaymentUrl}##",
	useRopcFlow: "##{useRopcFlow}##",
	userSessionNbMinutes: "##{userSessionNbMinutes}##",
};
